import React, {useState, useEffect} from "react";
import {Form, Button, InputGroup, Alert, Image, Card, Row, Col, Carousel, Container} from "react-bootstrap";
import axios from "axios";
import {useMobxState} from "../mobx/global-context";
import {useHistory} from "react-router-dom";
import {BsLockFill} from "react-icons/bs";
import {BsPersonFill} from "react-icons/bs";
import pkg from './../../package.json';
import {
    useLocation
} from "react-router-dom";
import {requestAPI} from "../services";
import Rule from "./rule";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export function ssoNextLogin(){
    document.location.replace(`https://learn.kku.ac.th/auth/kku/redirect.php?client_id=52ef0dd5-32b4-4bbb-a251-292554992290`)
}

const Login = () => {
    let query = useQuery();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [sso, setSSO] = useState(false);
    const state = useMobxState();
    const history = useHistory();

    useEffect(() => {
        let sso = query.get('sso');
        if (sso == 'kku') {
            setSSO(true);
            requestAPI('GET', '/ltic-auth/token', null, false)
                .then(data => {
                    let {access_token} = data;
                    localStorage.setItem('token', access_token);
                    console.log('access_token=====', access_token);
                })
                .catch(e => {
                    console.log(e.message);
                })
                .finally(() => {
                    document.location.replace(pkg.homepage);
                })
        }
    }, []);



    if (sso) return <Alert variant='info'>Authenizing...</Alert>
    return (
        <Container>
            <Card className="mt-4 mb-4">
                <Card.Body>
                    <Row>
                        <Col>
                            <div>
                                <Carousel>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src="banner/now.png"
                                            // alt="First slide"
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <Image
                                            className="d-block w-100"
                                            src="banner/2.png"
                                            // alt="Second slide"
                                        />
                                    </Carousel.Item>
                                </Carousel>
                                <div style={{display:"flex", justifyContent:"center"}} className="mt-3 d-none d-md-flex">
                                    <a onClick={e=>{
                                        e.preventDefault();
                                        ssoNextLogin();
                                    }} className="img-bt-default img-bt-login"></a>
                                    {/*<a href="https://ltic.kku.ac.th/booking/strapi/ltic-auth" className="img-bt-default img-bt-login"></a>*/}
                                </div>

                                <div style={{display:"flex", justifyContent:"center"}} className="mt-3 d-flex d-md-none">
                                    <a onClick={e=>{
                                        e.preventDefault();
                                        ssoNextLogin();
                                    }} style={{width:'152px',height:'42px'}} className="img-bt-default img-bt-login"></a>
                                    {/*<a href="https://ltic.kku.ac.th/booking/strapi/ltic-auth" style={{width:'152px',height:'42px'}} className="img-bt-default img-bt-login"></a>*/}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        </Container>

///////////////////// LOGIN ////////////////////////
        // <Form className="mt-4">
        //     <h3 className="mb-3">เข้าสู่ระบบ (Login)</h3>
        //     <Form.Group className="mb-3" controlId="formBasicEmail">
        //         <Form.Label>Email address</Form.Label>
        //         <Form.Control type="email" placeholder="Enter email" value={email} onChange={(event)=>{
        //             setEmail(event.target.value)
        //         }} />
        //     </Form.Group>
        //
        //     <Form.Group className="mb-3" controlId="formBasicPassword">
        //         <Form.Label>Password</Form.Label>
        //         <Form.Control type="password" placeholder="Enter password" value={password} onChange={(event)=>{
        //             setPassword(event.target.value)
        //         }}/>
        //     </Form.Group>
        //
        //     <Button variant="primary" type="submit" onClick={(event)=>{
        //         event.preventDefault();
        //         axios.post(pkg.api_url+"/auth/local",{
        //             "identifier": email,
        //             "password": password
        //         }).then((res)=>{
        //              let user = res.data.user;
        //              let jwt = res.data.jwt;
        //             state.setCurrentUser(user);
        //             state.setToken(jwt)
        //             history.push('/');
        //         })
        //     }} className="mr-2">
        //         Login
        //     </Button>
        //     {/*<Button variant='secondary' onClick={e=>document.location.replace(`${pkg.api_url}/ltic-auth`)}>LTIC SSO</Button>*/}
        // </Form>
    )
}
export default Login;
